import React from "react";
import {Button, Flex, useAuthenticator, useTheme} from "@aws-amplify/ui-react";
import {Link} from "react-router-dom";
import {FiUser} from "react-icons/fi";
import {RiMenuFoldLine, RiMenuUnfoldLine} from "react-icons/ri";
import coachingLogo from "../../assets/images/logo/logo-bianco-arancio2.svg"
import styles from './index.module.css';


const Navbar = (
  {
    hidden = false,
    courseMenuOpen = false,
    setCourseMenuOpen,
    userMenuOpen = false,
    setUserMenuOpen,
  }
) => {
  const {route} = useAuthenticator((context) => [
    context.route,
  ]);

  const {tokens} = useTheme();

  const isAuthenticated = route === 'authenticated'

  return (
    <Flex
      alignItems="center"
      justifyContent="space-between"
      backgroundColor={tokens.colors.brand.primary[100]}
      padding={tokens.space.large}
      style={{
        zIndex: 10,
        width: "100%",
        maxWidth: "100vw",
        position: "fixed",
        height: "90px",
        opacity: hidden ? 0 : 1,
        transition: ".3s all"
      }}
    >
      {
        isAuthenticated &&
        <Button
          size="large"
          onClick={() => setCourseMenuOpen(!courseMenuOpen)}
          style={{
            border: "none",
            color: tokens.colors.font.secondary
          }}
        >
          {
            courseMenuOpen ?
              <RiMenuFoldLine/> :
              <RiMenuUnfoldLine/>
          }
        </Button>
      }
      <Link
        to="/"
      >
        <img
          className={styles.logo}
          src={coachingLogo}
          alt="MyEdu Coaching"
        />
      </Link>
      {
        isAuthenticated &&
        <Button
          size="large"
          onClick={() => setUserMenuOpen(!userMenuOpen)}
          style={{
            border: "none",
            color: tokens.colors.font.secondary
          }}
        >
          <FiUser/>
        </Button>
      }
    </Flex>
  )
}

export default Navbar;